import type { ActivityChartData } from '../../api/types.ts';
export const EMPTY_DISPLAY_VALUE  = '—';
export const HEADER_BODY_MARGIN_TOP = 124;
export const HEADER_BODY_MARGIN_BOTTOM = 4 * 10;
export const DEFAULT_DEBOUNCE_DELAY = 500;
export const DEFAULT_RETRY_INTERVAL = 5000;
export const DEFAULT_RETRY_COUNT = 3;

export const TEMP_IMAGE_SRC = 'https://pyxis.nymag.com/v1/imgs/51b/28a/622789406b8850203e2637d657d5a0e0c3-avatar-rerelease.rsquare.w400.jpg';
export const TEMP_IMAGE_16_9_SRC = 'https://wallpaperswide.com/download/avatar_movie_2-wallpaper-1600x900.jpg';
export const TEMP_DATE_EXAMPLE = '2024-08-08T14:18:30.587489+03:00';
export const TEMP_REGIONS = ['Australia', 'USA', 'Japan'];
export const EMPTY_STRING = '';

export const INITIAL_PAGE = 1;
export const EMPTY_OPTION_SYMBOL = '\u00A0'; // Non-breaking space

export const FORM_DATA_NULL_VALUE = 'null';
export const EMPTY_VIEW_VALUE = '—';

export const TEMP_DATA_SET = new Array(30).fill(0).map((_, i) => {
  const base = new Date();
  base.setHours(0, 0, 0, 0);

  const d = new Date(base);
  d.setDate(base.getDate() - 29 + i);

  const value = Math.floor(Math.random() * 30);

  return {
    value,
    date: d.toISOString(),
  };
});
export const TEMP_DATA_SET_y = TEMP_DATA_SET.map((it) => {
  const value = Math.floor(Math.random() * 30);
  return {
    value,
    date: it.date,
  };
});
export const TEMP_DATA_SET_z = TEMP_DATA_SET.map((it) => {
  const value = Math.floor(Math.random() * 30);
  return {
    value,
    date: it.date,
  };
});

export const TEMP_ACTIVITY_BAR_CHART: ActivityChartData[] = TEMP_DATA_SET.map((it) => {
  return {
    ...it,
    value:
      Math.random() > 0.4 ? 1 : 0,
  };
});

export const TEMP_WEATHER_STATS = {
  weatherType: 'Cloudy',
  temperature: 59,
  humidity: 74,
  atmospheric_pressure: 760,
  wind_speed: 6,
  wind_direction: 'SW',
};
export const TRANSITION_DURATION = '250ms';



export const EXAMPLE_MP4 =
  'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4';

export const EXAMPLE_WEBM =
  'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.webm';

export const EXAMPLE_HLS_VOD =
  'https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8';

export const EXAMPLE_DASH_VOD =
  'https://dash.akamaized.net/akamai/bbb_30fps/bbb_30fps.mpd';

export const EXAMPLE_HLS_LIVE =
  'https://ll-hls-test.apple.com/master.m3u8';

export const EXAMPLE_DASH_LIVE =
  'https://livesim.dashif.org/livesim/mup_30/testpic_2s/Manifest.mpd';